/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ApplicationStateFactory, FormSchemaFactory } from '@gh/common-shared';
import { BuilderFormStateSchema } from './builder-form-state-schema';

@Injectable()
export class BuilderFormSchemaFactory extends FormSchemaFactory {
  constructor(private appStateFactory: ApplicationStateFactory) {
    super();
  }

  create(): BuilderFormStateSchema {
    return new BuilderFormStateSchema(this.appStateFactory);
  }
}
